"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../../../Layout/Flex"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var List = (0, _styledComponents.default)(_Flex.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  list-style-type: ", ";\n  list-style-position: inside;\n"], ["\n  list-style-type: ", ";\n  list-style-position: inside;\n"])), function (_a) {
  var styleType = _a.styleType;
  return styleType;
});
exports.List = List;
var templateObject_1;